class CookiesForm {
    /** @var {HTMLFormElement} */
    form;

    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        this.$el = el;
        el.querySelectorAll('[data-control]').forEach(el => el.addEventListener('click', e => this.cookiesSwitch(e)));
        this.toggles = el.querySelectorAll('input[type=checkbox]');
        this.form = el.querySelector('form');
        this.form.addEventListener('submit', e => this.onFormSubmitted(e));
    }

    /**
     * @param {MouseEvent} e
     */
    cookiesSwitch(e) {
        e.preventDefault();
        const toggle = Number.parseInt(e.currentTarget.dataset.toggle);
        this.toggles.forEach(el => el.checked = toggle === 1);

        const cookieConsentManager = new LinkCookieConsentManager(e.currentTarget.getAttribute('href'));
        cookieConsentManager.sendSelectedValues();
    }

    onFormSubmitted(e) {
        e.preventDefault();
        const data = new FormData(this.form);
        const cookieConsentManager = new FormCookieConsentManager(this.form.action, data);
        cookieConsentManager.sendSelectedValues();
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cookies-form]').forEach(el => new CookiesForm(el));
});

